// extracted by mini-css-extract-plugin
export default {"root":"AddTimeSlot_root__aXh7V","add-icon":"AddTimeSlot_add-icon__0O0Wm"};